// redux/slices/shopSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Shop } from '../../interfaces/user';

interface ShopState {
  shops: Shop[];
  loading: boolean;
  error: string | null;
}

const initialState: ShopState = {
  shops: [],
  loading: false,
  error: null
};

const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setShops(state, action: PayloadAction<Shop[]>) {
      state.shops = action.payload;
    },
    addShop(state, action: PayloadAction<Shop>) {
      state.shops.push(action.payload);
    },
    updateShop(state, action: PayloadAction<Shop>) {
      const index = state.shops.findIndex(s => s.id === action.payload.id);
      if (index !== -1) state.shops[index] = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    }
  }
});

export const { setShops, addShop, updateShop, setLoading, setError } = shopSlice.actions;
export default shopSlice.reducer;
